import { triggerCustomerIoUserLoggedIn } from "@/features/analytics/triggers";
import type { OnboardingUser } from "@/features/onboarding/models";

interface TrackUserLoggedInParams {
  userEmail: OnboardingUser["email"];
}

export const trackUserLoggedIn = ({ userEmail }: TrackUserLoggedInParams) => {
  triggerCustomerIoUserLoggedIn({ userEmail });
};
